import { config } from "../env";
import {
  Delete,
  DeleteWithPayload,
  get,
  post,
  postFileUpload,
} from "./helpers/http-handler";

//checkpoint
export const importVendorCheckpoint = (payload: object) =>
  postFileUpload(`${config.API_URL}/vendor-checkpoint/release/import`, payload);

export const importPECompliance = (payload: object) =>
  postFileUpload(`${config.API_URL}/pe-compliance/import/data`, payload);

export const importSelfCompliance = (payload: object) =>
  postFileUpload(`${config.API_URL}/self-compliance/import/data`, payload);

export const importInterlinkedCheckpoint = (payload: object) =>
  postFileUpload(`${config.API_URL}/self-compliance/update/interlinked-checkpoint`,payload);

export const importSelfComplianceBulkUpload = (payload: object) =>
  postFileUpload(
    `${config.API_URL}/bulk-update/self-complinace/master`,
    payload,
  );

//vendors

export const uploadVendors = (payload: object) =>
  postFileUpload(`${config.API_URL}/vendors/import`, payload);

export const uploadVendorsLocation = (payload: object) =>
  postFileUpload(`${config.API_URL}/vendors/location-import`, payload);

export const uploadVendorsHeadcount = (payload: object) =>
  postFileUpload(`${config.API_URL}/headcounts/import`, payload);

export const uploadVendorsUsers = (payload: object) =>
  postFileUpload(`${config.API_URL}/users/import`, payload);

//self compliance reports (Download)

export const downloadSelfComplianceReports = (payload: string) =>
  post(`${config.API_URL}/reports/self-compliance`, payload);

//Entity Mapping

export const downloadEntityMapping = (payload: object) =>
  postFileUpload(`${config.API_URL}/entity-mapping/import/data`, payload);

export const exportEntityMapping = (payload: object) =>
  post(`${config.API_URL}/reports/entity-mapping`, payload);

export const exportICEntityMapping = (payload: object) =>
  post(`${config.API_URL}/reports/ic-entity-mapping`, payload);

//Checkpoint

export const downloadOnPremCheckpoint = (payload: object) =>
  postFileUpload(`${config.API_URL}/checkpoint/import/data`, payload);

//legislation

export const uploadLegislation = (payload: object) =>
  postFileUpload(`${config.API_URL}/masters/import/legislation`, payload);

//legislation-rule

export const uploadLegislationRule = (payload: object) =>
  postFileUpload(`${config.API_URL}/masters/import/legislation-rule`, payload);

//State-Category-of-law

export const uploadStateCategoryOfLaw = (payload: object) =>
  postFileUpload(
    `${config.API_URL}/masters/import/state-category-of-law`,
    payload,
  );

// Client User

export const uploadClientUser = (payload: object) =>
  postFileUpload(`${config.API_URL}/users/client/import`, payload);

// Client User Entity Mapping

export const uploadUserEntityMapping = (payload: object) =>
  postFileUpload(`${config.API_URL}/user-entity-permissions/import`, payload);

export const downloadLegacyTaskReports = (payload: string) =>
  post(`${config.API_URL}/reports/legacy-task`, payload);

// Release Dates

export const uploadReleaseDates = (payload: object) =>
  postFileUpload(`${config.API_URL}/release-dates/import/data`, payload);

// Assigned Task Reports Download
export const downloadAssignedTaskReports = (payload: string) =>
  post(`${config.API_URL}/reports/checkpoint-assigned-task`, payload);

export const uploadVendorsUserLocationMapping = (payload: object) =>
  postFileUpload(`${config.API_URL}/locations/location/attach/import`, payload);

export const deleteImports = (id: string) =>
  Delete(`${config.API_URL}/imports/${id}`);

export const uploadUserLocationMapping = (payload: object) =>
  postFileUpload(
    `${config.API_URL}/locations/location/user/attach/import`,
    payload,
  );

export const uploadVendorsEmailLocationMapping = (payload: object) =>
  postFileUpload(`${config.API_URL}/vendors/import/email`, payload);

export const uploadSelfComplianceTaskBulkMapping = (payload: object) =>
  postFileUpload(`${config.API_URL}/bulk-update/update/data`, payload);

export const uploadVendorCheckpointBulk = (payload: object) =>
  postFileUpload(`${config.API_URL}/vendor-checkpoint/bulk/update`, payload);

export const uploadSelfComplianceConfigBulkMapping = (payload: object) =>
  postFileUpload(`${config.API_URL}/bulk-update/config/data`, payload);

export const deleteExports = (payload: object) =>
  DeleteWithPayload(`${config.API_URL}/reports`, payload);

export const uploadLegacyBulkImport = (payload: object) =>
  postFileUpload(`${config.API_URL}/legacy-tasks/bulk-import`, payload);

export const uploadLegacyBulkUpdateTask = (payload: object) =>
  postFileUpload(`${config.API_URL}/legacy-tasks/bulk-Update-task`, payload);

export const uploadLegacyBulkUpdateDocument = (payload: object) =>
  postFileUpload(
    `${config.API_URL}/legacy-tasks/bulk-Improt-document`,
    payload,
  );

export const uploadLicenseCheckpoint = (payload: object) =>
  postFileUpload(
    `${config.API_URL}/license-task/location/import/data`,
    payload,
  );

export const uploadLicenseTaskUpdate = (payload: object) =>
  postFileUpload(`${config.API_URL}/license-task/task/update/import`, payload);

export const uploadLicenseUpdate = (payload: object) =>
  postFileUpload(
    `${config.API_URL}/license-task/location/import/data/update`,
    payload,
  );

export { downloadLicenseTaskUpdateTemplate } from "./license.service";
